const getRepValueForSelect = (
  curr_value: string,
  values?: { code: string; name: string }[],
): { value: string; label: string } | undefined => {
  const representative = values?.find(v => v.code === curr_value);

  return (
    representative && {
      value: representative.code,
      label:
        representative.code === 'ALL'
          ? 'Todos'
          : `(${representative.code}) - ${representative.name}`,
    }
  );
};

export default getRepValueForSelect;
